import {type MantineStyleProp, Paper} from "@mantine/core";
import Surface from "@components/surface";
import type React from "react";

type JarvisCardProps = {
    style?: MantineStyleProp ;
    children: React.ReactNode;
    className?: string ;
};

const JarvisCard = ({style, children, className}: JarvisCardProps) => {
    return (
        <Surface component={Paper} {...{
            p: 'md',
            shadow: 'none',
            withBorder: true,
            radius: 'md',
            style: {height: '100%'},
        }
        } style={style ?? {padding: 16, marginBottom: 16, height: 'auto'}} className={className ?? ''}>
            {children}
        </Surface>
    );
};

export default JarvisCard;
